import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useRealtimeEvent } from '@/realtime/useRealtimeEvent';
import { presenceApi } from '@/services/api/presence/presence';

export const presenceKeys = {
  all: ['admin', 'presence'] as const,
};

/**
 * Current presence, kept fresh by the gateway's `presence.changed` signal.
 * The event carries no payload — it just tells us the snapshot moved, so we
 * refetch and keep one response shape defined server-side.
 */
export function usePresenceQuery() {
  const queryClient = useQueryClient();

  const onChanged = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: presenceKeys.all });
  }, [queryClient]);

  useRealtimeEvent('presence.changed', onChanged);

  return useQuery({
    queryKey: presenceKeys.all,
    queryFn: () => presenceApi.getAll(),
    // Safety net for when the socket doesn't reconnect (e.g. an API restart
    // outlasts RealtimeProvider's reconnection attempts) — without this the
    // page would otherwise freeze on a stale snapshot with no error state.
    refetchInterval: 60_000,
  });
}
